module.exports = __webpack_public_path__ + "static/media/arrow-down_24x24.ffe5599a.svg";